<template>
  <success-popup
    show="{{showSuccessPopup}}"
    type="{{type}}"
    bind:close="triggerSuccessPopup"
  />
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'
import store from '@/store'

createComponent({
  props: {
    originalStatus: {
      type: Number,
      value: 0
    },
    feebackFlag:{
      type: Boolean,
      value: false
    }
  },
  computed: {
    ...store.mapState({
      curSpeedStatus: 'order.curSpeedStatus',
      packageInfo: 'order.package_info',
      baseInfo: 'order.base_info',
    }),
  },
  data: {
    showSuccessPopup:false,
    type:1
  },
  methods: {
    triggerSuccessPopup(){
      this.showSuccessPopup = !this.showSuccessPopup
    }
  },
  watch:{
    curSpeedStatus: {
      handler(val, old) {
        if (this.showSuccessPopup) return 
        if (this.packageInfo.packages===null) return
        console.error('-----curSpeedStatus',val, old, this.originalStatus)
        if (old===undefined) {
          // 刚进入页面
          if(this.originalStatus && val!=this.originalStatus) {
            this.triggerSuccessPopup()
          }
          // if(!this.originalStatus){
          //   if(this.feebackFlag){
          //     this.triggerSuccessPopup()
          //   }
          // }
        }else{
          this.triggerSuccessPopup()
        }
      },
      immediate:true
    },
  }
})
</script>

<style scoped lang="stylus">
</style>

<script name="json">
module.exports = {
  component: true,
  usingComponents: {
    'success-popup': './success-popup'
  }
}
</script>